import Styles from './Intro.module.scss'

export const Intro = () => {
  return (
    <div>
      <p className={Styles.description}>
        Status Automations help you automate away your process chaos. They allow you to create lightweight workflows
        that provide process guardrails for your team to follow.
      </p>
    </div>
  )
}
